export default {
  state: {
    theme: 'light',
  },
  mutations: {
    UPDATE_THEME(state, theme) {
      state.theme = theme;
    },
  },
  actions: {
    updateTheme({ commit }, data) {
      commit('UPDATE_THEME', data);
    },
  },
  getters: {
    theme: state => state.theme,
  },
};
